import { render, staticRenderFns } from "./psq-table.vue?vue&type=template&id=1ba5950f&scoped=true"
import script from "./psq-table.vue?vue&type=script&lang=js"
export * from "./psq-table.vue?vue&type=script&lang=js"
import style0 from "./psq-table.vue?vue&type=style&index=0&id=1ba5950f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba5950f",
  null
  
)

export default component.exports